// removed by extract-text-webpack-plugin
module.exports = {"ant-dropdown-link":"TopPanel__ant-dropdown-link___2EPZJ","header":"TopPanel__header___2yIAT","siteTitle":"TopPanel__siteTitle___2OSJ6","crm-logo":"TopPanel__crm-logo___34HeC","setupBtn":"TopPanel__setupBtn___2l79c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/TopPanel/TopPanel.less
// module id = 167
// module chunks = 3